import type { Locale } from "@/i18n";
import type { Choice, Question } from "@/lib/types";

/** Get localized question text. Falls back across locale variants when the preferred field is empty. */
export function getQuestionText(q: Question, locale: Locale): string {
  if (locale === "en" && q.text_en) return q.text_en;
  if (q.text_ko) return q.text_ko;
  return q.text_en ?? "";
}

/** Get localized choice text. Falls back to the other locale when the preferred field is empty. */
export function getChoiceText(c: Choice, locale: Locale): string {
  if (locale === "en" && c.text_en) return c.text_en;
  if (c.text) return c.text;
  return c.text_en ?? "";
}

/** Get localized explanation. Falls back to the other locale when the preferred field is empty. */
export function getExplanation(q: Question, locale: Locale): string | undefined {
  if (locale === "en" && q.explanation_en) return q.explanation_en;
  return q.explanation || q.explanation_en;
}
